import { FieldError, RegisterOptions, useFormContext } from "react-hook-form";

import Textarea from "@/components/atoms/input/Textarea";
import FormControl, { FormControlProps } from "@/components/molecules/form/FormControl";

type FormTextareaProps = {
  name: string;
  rules?: RegisterOptions;
  disabled?: boolean;
  placeholder?: string;
} & Omit<FormControlProps, "id" | "children">;

const FormTextarea = ({ name, rules, disabled = false, placeholder, ...rest }: FormTextareaProps) => {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  const error = errors[name] as FieldError | undefined;

  return (
    <FormControl id={name} error={error?.message} {...rest}>
      <Textarea id={name} {...register(name, rules)} hasError={!!error} disabled={disabled} placeholder={placeholder} />
    </FormControl>
  );
};

export default FormTextarea;
